<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{$t('profile.material.feedspecs')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <MaterialFeedSpecForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import MaterialFeedSpecForm from '../../components/materialfeedspec/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'MaterialFeedSpec';

const { mapFields } = createHelpers({
  getterType: 'materialfeedspec/getField',
  mutationType: 'materialfeedspec/updateField'
});

export default {
  name: 'MaterialFeedSpecCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    MaterialFeedSpecForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('materialfeedspec', ['create', 'reset'])
  }
};
</script>
